const typeTab = (() => {
  const pageType = (document.getElementById("pageType") != null);
  if (pageType) {

    const tabWrap = document.querySelectorAll('.js-tab-wrap');
    if (tabWrap.length > 0) {



      const secType = document.querySelector("#jsSecType")
      const tabBoxs = secType.querySelectorAll('.js-tab-box');
      const typeBoxs = secType.querySelectorAll('.js-type-box');
      const imgBoxs = secType.querySelectorAll('.js-img-box');
      const plotBoxs = secType.querySelectorAll('.js-plot-box');
      const copyBox = secType.querySelector('.js-copy-box');


      let url = new URL(window.location.href);
      let params = url.searchParams;
      let paramsNum = params.get('menu')
      console.log(paramsNum);

      if (paramsNum == 1) {
        tabBoxs[1].classList.add('act');
        typeBoxs[1].classList.add('act');
        imgBoxs[1].classList.add('act');
        plotBoxs[1].classList.add('act');
      } else if (paramsNum == 2) {
        tabBoxs[2].classList.add('act');
        typeBoxs[2].classList.add('act');
        imgBoxs[2].classList.add('act');
        plotBoxs[2].classList.add('act');
      } else {
        tabBoxs[0].classList.add('act');
        typeBoxs[0].classList.add('act');
        imgBoxs[0].classList.add('act');
        plotBoxs[0].classList.add('act');
        copyBox.classList.add('act');
      }


      tabBoxs.forEach((element, index) => {
        element.addEventListener('click', () => {

          for (let i = 0; i < tabBoxs.length; i++) {
            tabBoxs[i].classList.remove('act');
            typeBoxs[i].classList.remove('act');
            imgBoxs[i].classList.remove('act');
            plotBoxs[i].classList.remove('act');
            copyBox.classList.remove('act');
          }
          tabBoxs[index].classList.add('act');
          typeBoxs[index].classList.add('act');
          imgBoxs[index].classList.add('act');
          plotBoxs[index].classList.add('act');

          if (index == 0) {
            copyBox.classList.add('act');
          }

        });
      });





    }

  }
})()
export default typeTab;